import { atom, useAtom } from "jotai";

import { type BudgetMixChartDatum } from "../budget-mix-chart/segmented-chart";

const historicalBudgetMixDataAtom = atom<BudgetMixChartDatum[]>([]);

export const useHistoricalBudgetMix = () => {
  const [historicalBudgetMixData, setHistoricalBudgetMixData] = useAtom(
    historicalBudgetMixDataAtom,
  );
  return { historicalBudgetMixData, setHistoricalBudgetMixData };
};
